<template>
  <section class="section">
    <h2 class="sub-title">
      {{ Ranking.all[lang] }}
    </h2>
    <!-- 絞り込み -->
    <div class="narrow-down">
      <h3 class="h3-title">
        {{ Ranking.filter[lang] }}
      </h3>
      <p class="how-to-use">
        {{ Ranking.multi[lang] }}
      </p>
      <!-- 性別 -->
      <dl class="narrow-down-list">
        <dt class="narrow-down-list__team">
          <label for="gender-id" class="label">
            {{ Ranking.sex[lang] }}
          </label>
        </dt>
        <dd class="narrow-down-list__description">
          <select
            id="gender-id"
            name="gender"
            v-model="selectGender"
            class="select"
          >
            <option value="" selected>
              {{ Ranking.reserve[lang] }}
            </option>
            <option value="1">
              {{ Ranking.male[lang] }}
            </option>
            <option value="2">
              {{ Ranking.female[lang] }}
            </option>
          </select>
        </dd>
      </dl>
      <!-- 年代 -->
      <dl class="narrow-down-list">
        <dt class="narrow-down-list__team">
          <label for="age-id" class="label">
            {{ Ranking.age[lang] }}
          </label>
        </dt>
        <dd class="narrow-down-list__description">
          <select id="age-id" name="age" v-model="selectAge" class="select">
            <option value="" selected>
              {{ Ranking.reserve[lang] }}
            </option>
            <option value="0,19">~19</option>
            <option value="20,24">20~24</option>
            <option value="25,29">25~29</option>
            <option value="30,34">30~34</option>
            <option value="35,39">35~39</option>
            <option value="40,44">40~44</option>
            <option value="45,49">45~49</option>
            <option value="50,54">50~54</option>
            <option value="55,59">55~59</option>
            <option value="60,64">60~64</option>
            <option value="65,69">65~69</option>
            <option value="70,74">70~74</option>
            <option value="75,79">75~79</option>
            <option value="80,120">80~</option>
          </select>
        </dd>
      </dl>
      <!-- 居住地 --><!-- 海外参加あり TODO 1つにしたい -->
      <dl class="narrow-down-list">
        <dt class="narrow-down-list__team">
          <label for="pref-id" class="label">
            {{ Ranking.location[lang] }}
          </label>
        </dt>
        <dd class="narrow-down-list__description">
          <label for="area-id"></label>
          <select
            id="area-id"
            class="select"
            name="area"
            v-model="selectArea"
            @change="changeSelectArea"
          >
            <option value="" selected>
              {{ Ranking.reserve[lang] }}
            </option>
            <option
              v-for="(area, index) in dataEventSummary.areas"
              :key="index"
              :value="area.code"
            >
              {{ area.name[lang] }}
            </option>
          </select>
        </dd>
        <dd class="narrow-down-list__description" v-if="!isSelectCountry">
          <select
            id="pref-id"
            class="select"
            name="area"
            v-model="selectCountry"
            :disabled="isSelectCountry"
          >
            <option value="" selected>
              {{ Ranking.reserve[lang] }}
            </option>
            <option
              v-for="(country, index) in selectCountries()"
              :key="index"
              :value="country.code"
            >
              {{ country.name[lang] }}
            </option>
          </select>
        </dd>
      </dl>
      <div class="narrow-down-search">
        <button type="button" @click="emitTypeNarrowingDown" class="button">
          <img
            class="filter-img"
            src=".././../../assets/images/filter.svg"
            alt=""
          />
          <span>
            {{ Ranking.apply[lang] }}
          </span>
        </button>
      </div>
      <div class="narrow-down-search">
        <button type="button" @click="emitRanking" class="button">
          {{ Ranking.clear[lang] }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Ranking from "../../../assets/constants/ranking/ranking.json";

export default {
  data() {
    return {
      isSelectCountry: true,
      selectCountry: "",
      selectGender: "",
      selectAge: "",
      selectArea: "",
    };
  },
  methods: {
    /**
     * 居住地(エリア)を変更時に発火するイベント
     */
    changeSelectArea: function () {
      this.selectCountry = "";
      this.selectArea
        ? (this.isSelectCountry = false)
        : (this.isSelectCountry = true);
    },

    /**
     * 居住地(エリア)の変更が検知されたら発火するイベント
     * 値によって都道府県、または選択した国地域のリストを返却します
     */
    selectCountries: function () {
      return this.dataEventSummary.areas.find(
        (area) => area.code === this.selectArea
      ).countries;
    },

    emitTypeNarrowingDown: function () {
      this.$emit(
        "type-narrowing-down",
        this.selectGender,
        this.selectAge,
        this.selectArea,
        this.selectCountry,
        "",
        "",
        ""
      );
    },

    emitRanking: function () {
      // 絞り込み初期化
      this.selectGender = "";
      this.selectAge = "";
      this.selectArea = "";
      this.selectCountry = "";
      this.$emit("initial-ranking");
    },
  },
  props: {
    dataEventSummary: Object,
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  name: "ForeignRefinedSearch",
};
</script>

<style scoped>
.narrow-down {
  margin: 25px 0 0 0;
  padding: 30px 25px 28px 25px;
  background-color: var(--defaultGrayColor);
  .h3-title {
    font-size: 24px;
  }
  .how-to-use {
    margin: 10px 0 0 0;
    font-size: 14px;
  }
  .narrow-down-list {
    margin: 20px 0 0 0;
    &:first-of-type {
      margin: 30px 0 0 0;
    }
    &__team {
      line-height: 1;
      font-size: 20px;
      font-weight: bold;
      color: var(--defaultBlackColor);
    }
    &__description {
      margin: 10px 0 0 0;
      .select {
        padding: 0 0 0 15px;
        width: 100%;
        height: 40px;
        border-radius: 6px;
        font-size: 16px;
        color: var(--defaultBlackColor);
        border: solid 1px var(--defaultBlackColor);
        background: var(--defaultWhiteColor)
          url("../../../assets/images/arrow-down.svg") no-repeat center right
          10px;
      }
    }
  }
  .narrow-down-search {
    margin: 20px 0 0 0;
    text-align: center;
    .button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 140px;
      height: 45px;
      border: solid 1px var(--defaultBlackColor);
      background-color: var(--defaultWhiteColor);
      .filter-img {
        margin: 0 4px 0 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/ranking/ForeignRefinedSearch.vue